import { Card, Divider, Text, cn } from '@billda/design-system';
import { format, parseISO } from 'date-fns';
import { LabelValueRow } from '../LabelValueRow';
import type { PotAutoSubmit, PotDeadlines } from '../../types/potDetails.types';

interface PotStatusDeadlinesCardProps {
  deadlines: PotDeadlines | null;
  autoSubmit: PotAutoSubmit;
  className?: string;
}

export function PotStatusDeadlinesCard({
  deadlines,
  autoSubmit,
  className,
}: PotStatusDeadlinesCardProps) {
  const formatDateShort = (dateString: string) =>
    format(parseISO(dateString), 'dd MMM yyyy');

  return (
    <Card
      data-testid="pot-status-deadlines-card"
      className={cn('h-full p-4 sm:p-6', className)}
    >
      <Text variant="h6" className="mb-4">
        Deadlines
      </Text>

      {deadlines && (
        <div className="flex flex-col gap-1">
          <LabelValueRow
            label="Book-in by"
            value={formatDateShort(deadlines.bookInBy)}
          />
          <LabelValueRow
            label="Verify by"
            value={formatDateShort(deadlines.verifyBy)}
          />
          <LabelValueRow
            label="Submit by"
            value={formatDateShort(deadlines.submitBy)}
          />
        </div>
      )}

      <Divider className="my-3" />
      <div className="flex flex-col gap-1">
        <LabelValueRow
          label="Auto-submit"
          value={
            <Text
              variant="body2"
              className={
                autoSubmit.isScheduled
                  ? 'font-medium text-content-info'
                  : 'text-content-secondary'
              }
              data-testid="pot-auto-submit-status"
            >
              {autoSubmit.isScheduled ? 'Scheduled' : 'Not scheduled'}
            </Text>
          }
        />
        <LabelValueRow
          label="Recurring"
          value={
            <Text
              variant="body2"
              className={
                autoSubmit.isRecurringEnabled
                  ? 'font-medium text-content-success'
                  : 'text-content-secondary'
              }
              data-testid="pot-recurring-auto-submit-status"
            >
              {autoSubmit.isRecurringEnabled ? 'Enabled' : 'Off'}
            </Text>
          }
        />
      </div>
    </Card>
  );
}
